<template>
  <material-card
    :title="$t('components.hsa_import.import_hsa_credit')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="publish"
  >
    <v-card-text>
      <v-row>
        <v-col class="col-auto">
          <v-dialog v-model="validationTipsDialog" width="500">
            <template v-slot:activator="{ on }">
              <v-btn color="success" dark v-on="on">
                {{
                  $t("components.membersimportwizardcomponent.validation_rules")
                }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title
                style="background:#4caf50;color: white;"
                class="headline lighten-2"
                primary-title
              >
                {{
                  $t("components.membersimportwizardcomponent.validation_rules")
                }}
              </v-card-title>
              <v-card-text>
                <div style="padding-top:5px"></div>

                <strong>
                  {{ $t("components.membersimportwizardcomponent.dates") }}:
                </strong>
                {{
                  $t(
                    "components.membersimportwizardcomponent.columns_that_contain_date_values_must_have_their_format_cell"
                  )
                }}
                <v-divider />
                <div v-if="columns">
                  <template v-if="requiredColumns.length > 0">
                    <strong>
                      {{
                        $t(
                          "components.membersimportwizardcomponent.required_columns"
                        )
                      }}:
                    </strong>
                    <span>
                      {{
                        requiredColumns
                          .map((f) => $t("headers.members_management." + f.text))
                          .join(", ")
                      }}
                    </span>
                  </template>
                  <v-divider />
                  <template v-if="optionalColumns.length > 0">
                    <strong>
                      {{
                        $t(
                          "components.membersimportwizardcomponent.optional_columns"
                        )
                      }}:
                    </strong>
                    <span>
                      {{
                        optionalColumns
                          .map((f) => $t("headers.hsa_import." + f.name))
                          .join(", ")
                      }}
                    </span>
                  </template>
                </div>
                <v-divider />
                <strong>
                  {{ $t("components.hsaimport.validation") }}
                </strong>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn
                  color="primary"
                  text
                  @click="validationTipsDialog = false"
                >
                  {{ $t("globals.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-form v-model="valid">
        <v-container>
          <v-row justify-center>
            <v-col cols="12">
              <v-file-input
                show-size
                accept=".xlsx"
                :label="$t('views.billingwizard.billing_import_select')"
                ref="file"
                v-on:change="handleFileChange"
                :rules="[$rules.required]"
                class="required"
                v-model="file"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-alert
        v-for="(error, i) in errors"
        dense
        type="error"
        :key="i"
        dismissible
      >
        {{ $t(error) }}
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="$emit('close')" :loading="saving">
        {{ $t("globals.close") }}
      </v-btn>
      <v-btn
        color="primary"
        @click="save"
        :disabled="!valid || errors.length > 0"
        :loading="saving"
      >
        {{ $t("globals.import") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
    <v-snackbar v-model="snackbar" color="success" :timeout="2500">
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </material-card>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      file: null,
      errors: [],
      validationTipsDialog: false,
      columns: [
        {
          name: "certificate",
          text: "Certificate",
          isOptional: false,
        },
        {
          name: "year",
          text: "Year",
          isOptional: false,
        },
        {
          name: "amount",
          text: "Amount",
          isOptional: false,
        },
        {
          name: "effectivedate",
          text: "Effective Date",
          isOptional: false,
        },
      ],
      snackbar: false,
    };
  },
  computed: {
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    optionalColumns() {
      return this.columns.filter((o) => o.isOptional);
    },
    requiredColumns() {
      return this.columns.filter((o) => !o.isOptional);
    },
  },
  methods: {
    ...mapActions("claims", ["importHsa"]),
    handleFileChange(file) {
      if (!file) {
        this.file = null;
        this.errors = [];
        return;
      }
      if (file.length == 0) {
        this.errors = [];
        return;
      }
      this.file = file;
    },
    async save() {
      try {
        this.saving = true;
        await this.importHsa({
          planIdentityId: this.selectedPlan.Id,
          file: this.file,
        });
        this.snackbar = true;
        let t = setTimeout(() => {
          clearTimeout(t);
          this.$emit("finish");
        }, 2500);
      } catch (error) {
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 3000
        ) {
          const errors = JSON.parse(error.response.data.Message);
          console.log(errors);
          if (errors["3001"] !== null && errors["3001"] !== undefined) {
            for (const row of errors["3001"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3001_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["3002"] !== null && errors["3002"] !== undefined) {
            for (const row of errors["3002"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3002_{0}_{1}", [
                  row.row,
                  row.column,
                ])
              );
            }
          }
          if (errors["3003"] !== null && errors["3003"] !== undefined) {
            for (const row of errors["3003"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3003_{0}_{1}_{2}", [
                  row.row,
                  row.column,
                  row.type,
                ])
              );
            }
          }
          if (errors["3005"] !== null && errors["3005"] !== undefined) {
            for (const row of errors["3005"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3005_{0}", [
                  row.row.toString(),
                ])
              );
            }
          }
          if (errors["3006"] !== null && errors["3006"] !== undefined) {
            for (const row of errors["3006"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3006_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["3007"] !== null && errors["3007"] !== undefined) {
            for (const row of errors["3007"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3007_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["3008"] !== null && errors["3008"] !== undefined) {
            for (const row of errors["3008"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3008_{0}_{1}", [
                  row.row.toString(), row.column.toString()
                ])
              );
            }
          }
          if (errors["3009"] !== null && errors["3009"] !== undefined) {
            for (const row of errors["3009"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_3009_{0}_{1}_{2}", [
                  row.row.toString(), row.column.toString(), row.employer.toString()
                ])
              );
            }
          }
        } else if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 3004
        ) {
          this.errors.push(this.$t("components.errorhandler.error409_3004"));
        } else {
          this.error = error;
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style></style>
